import GroupRoleModelingBox from "./group-role-modeling-box.jsx";

export default GroupRoleModelingBox;